const CONTACT_TYPES = ['business', 'emergency'];
const CONTACT_DETAIL_FIELDS = ['telephoneNumber', 'emailAddress', 'webForm', 'singleLineAddress'];
const EXPLICIT_ASSET_CONTACT_KEYS = ['assetContacts', 'assetContact', 'assetContactDetails', 'assetContactRecords'];
const ASSET_OWNER_GROUP_KEYS = ['assetsInAOIOwners', 'operationalZone', 'nationalOrRegional'];

const hasValue = (value) => typeof value === 'string' ? value.trim().length > 0 : Boolean(value);

const hasContactInfo = (contact = {}) => {
    return CONTACT_DETAIL_FIELDS.some(field => hasValue(contact?.[field]));
};

const hasContacts = (contacts = {}) => {
    return CONTACT_TYPES.some(type => Array.isArray(contacts?.[type]) && contacts[type].some(hasContactInfo));
};

const getFirstPopulatedContactKey = (assetSource = {}, includeGenericContactsKey = false) => {
    const contactKeys = includeGenericContactsKey
        ? [...EXPLICIT_ASSET_CONTACT_KEYS, 'contacts']
        : EXPLICIT_ASSET_CONTACT_KEYS;

    return contactKeys.find(key => hasContacts(assetSource?.[key]));
};

export const getAssetContacts = ({ assetSource = {}, includeGenericContactsKey = false } = {}) => {
    const populatedContactKey = getFirstPopulatedContactKey(assetSource, includeGenericContactsKey);

    return populatedContactKey ? assetSource[populatedContactKey] : null;
};

export const getAssetOwnerRecords = (assetOwnersData = {}) => {
    return ASSET_OWNER_GROUP_KEYS.flatMap(groupKey => {
        return Array.isArray(assetOwnersData?.[groupKey]) ? assetOwnersData[groupKey] : [];
    });
};

export const getAssetOwnerRecordByDataProviderId = ({ assetOwnersData = {}, dataProviderId = null } = {}) => {
    if (!dataProviderId) {
        return null;
    }

    return getAssetOwnerRecords(assetOwnersData).find(record => record?.dataProviderId === dataProviderId) || null;
};

export const getAssetOwnerContactsByDataProviderId = ({ assetOwnersData = {}, dataProviderId = null } = {}) => {
    const assetOwnerRecord = getAssetOwnerRecordByDataProviderId({ assetOwnersData, dataProviderId });

    return hasContacts(assetOwnerRecord?.contacts) ? assetOwnerRecord.contacts : null;
};
